module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-26.c35a59e9.jpg";